import { isNotEmptyString } from '@racemap/utilities/functions/utils';

/** Asserts that an environment variable is set and returns its value. Throws if the value is empty, unless `SKIP_ENV_CHECK=true`. */
export function checkEnv<E extends Record<string, string | undefined>>(
  env: E[keyof E],
  key: keyof E,
): string {
  if (process.env.SKIP_ENV_CHECK === 'true') return env as string;
  if (isNotEmptyString(env)) return env;

  throw new Error(
    `Environment variable ${(key as string).replace('VITE_', '') as string} is not set`,
  );
}

const hasToBeHidden: Array<string> = ['KEY', 'TOKEN', 'SECRET', 'PASSWORD'];

/** Logs all environment variables to stdout when `DO_PRINT_ENV_VARS=true`. Redacts values whose key contains `KEY`, `TOKEN`, `SECRET`, or `PASSWORD`. */
export const logEnvVars = (envVars: { [name: string]: unknown }): void => {
  const DO_PRINT_ENV_VARS = process.env.DO_PRINT_ENV_VARS === 'true';
  if (DO_PRINT_ENV_VARS) {
    Object.entries({ ...envVars, DO_PRINT_ENV_VARS }).forEach(([key, value]) => {
      if (value != null) {
        const isHidden = hasToBeHidden.some((hidden) => key.toUpperCase().includes(hidden));
        if (isHidden) {
          console.log(`\x1b[35m${key}\x1b[0m: \x1b[31m***\x1b[0m`);
        } else {
          console.log(`\x1b[35m${key}\x1b[0m: \x1b[36m${value ?? ''}\x1b[0m`);
        }
      } else {
        console.log(
          `\x1b[35m${key}\x1b[0m: \x1b[31m??? => This environment variable is not defined!\x1b[0m`,
        );
      }
    });
  }
};
